import { render } from "./BalanceSheetLayout.vue?vue&type=template&id=82f285d6&bindings={\"id\":\"props\",\"loading\":\"data\",\"loadSpreadsheet\":\"options\"}"
import script from "./BalanceSheetLayout.vue?vue&type=script&lang=js"
export * from "./BalanceSheetLayout.vue?vue&type=script&lang=js"
script.render = render

export default script